<template>
  <div class="d-inline">
    <b-button id="general-map-preferences-icon" size="sm" variant="link" @click.stop.prevent v-b-modal.modalGeneralMapPreferences>
      <font-awesome-icon icon="cog" />
    </b-button>
    <b-modal size="md" id="modalGeneralMapPreferences" ref="modalGeneralMapPreferences" hide-footer>
      <template #modal-title><translate>General Map Preferences</translate></template>
      <template #modal-header-close><img src="@/assets/img/ic_close.svg" alt="×" /></template>
      <h5 v-translate>Entity Visualization and Refresh Rate</h5>
      <div v-for="layerKey of availableLayers" :key="layerKey" v-if="preferences && preferences.entities && mapLayersConfig[layerKey]" class="mt-3">
        <b-form-group>
          <b-form-checkbox v-model="preferences.entities" :value="layerKey">
            {{ getLayerLabel(layerKey) }}
          </b-form-checkbox>
          <div class="ml-3">
            <b-form-checkbox v-model="preferences.clustered[layerKey]" v-if="mapLayersConfig[layerKey].clustered !== undefined">
              <translate>Clustered</translate>
            </b-form-checkbox>
            <b-form-input
              v-if="mapLayersConfig[layerKey].timeout"
              v-model="preferences.timeout[layerKey]"
              type="range"
              :min="minEntityTimeout(layerKey) / 1000"
              max="3600"
              step="30"
              :disabled="!preferences.entities.includes(layerKey)"
            />
            <b-form-text
              v-if="mapLayersConfig[layerKey].timeout"
              v-translate="{min: minEntityTimeout(layerKey) / 1000, current: preferences.timeout[layerKey]}"
            >
              Min.: %{min} seconds, <strong>Current: %{current} seconds</strong>
          </b-form-text>
          </div>
        </b-form-group>
      </div>
      <div class="text-right mt-3">
        <b-button variant="primary" @click="savePreferences" v-translate>Apply</b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import MapLayersConfigMixin from '@/mixins/mapLayersConfig.mixin'

export default {
  name: 'GeneralMapPreferences',
  mixins: [MapLayersConfigMixin],
  props: {
    preferences: {
      type: Object,
      required: true
    },
    availableLayers: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    minEntityTimeout(layerKey) {
      if (!this.mapLayersConfig || !this.mapLayersConfig[layerKey]) return null
      return this.mapLayersConfig[layerKey].timeout || null
    },
    getLayerLabel(layerKey) {
      if (!this.mapLayersConfig || !this.mapLayersConfig[layerKey]) return layerKey
      return this.mapLayersConfig[layerKey].label || layerKey
    },
    savePreferences() {
      this.setLocalStorage('generalMapPreferences', this.preferences)
      this.$root.$emit('apply-map-preferences')
      this.$refs.modalGeneralMapPreferences.hide()
    }
  }
}
</script>

<style scoped>
#general-map-preferences-icon {
  cursor: pointer;
  transition: transform 0.2s ease;
  border-radius: 100%;
}

#general-map-preferences-icon:hover {
  transform: rotate(20deg);
}
</style>